module.exports = __webpack_public_path__ + "static/media/append-rows-icon.ecb3f9ad.svg";